import { Component, Input } from '@angular/core';
import { RouterLink } from "@angular/router";
import { ACNPipe } from "@shared/pipes/acnPipe";
import { getAnnualStatementsPath, getImportedAnnualStatementPagePath } from "@shared/utils/route-path-utils";
import { ICellRendererParams } from "ag-grid-community";
import { AnnualStatementRecord } from "@models/annual-statements/annual-statement-record";
import { ICellRendererAngularComp } from "ag-grid-angular";
import {
  EntityNameNumberRecordComponent
} from "@shared/components/commons/entity-name-number-record/entity-name-number-record.component";

type CellRendererParams = ICellRendererParams<AnnualStatementRecord> & {
  canBeOpened: boolean;
}

@Component({
  selector: 'app-ag-annual-name-acn',
  standalone: true,
  imports: [
    ACNPipe,
    EntityNameNumberRecordComponent,
    RouterLink
  ],
  templateUrl: './ag-annual-name-acn.component.html',
  styleUrl: './ag-annual-name-acn.component.scss'
})
export class AgAnnualNameAcnComponent implements ICellRendererAngularComp {
  @Input() name = '';
  @Input() acn = '';
  @Input() documentId = '';
  @Input() canBeOpened = false;
  @Input() link: string[] | null = null;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.name = params.data?.companyName ?? '';
    this.acn = params.data?.acn ?? '';
    this.documentId = params.data?.documentId ?? '';
    this.canBeOpened = params.canBeOpened && !!this.documentId;
    this.link = this.getLink(params.data);
    return true;
  }

  getLink(annualStatementRecord: AnnualStatementRecord | null | undefined): string[] | null {
    if (!this.canBeOpened || !annualStatementRecord) return null;
    if (AnnualStatementRecord.isImportedDocument(annualStatementRecord)) return getImportedAnnualStatementPagePath(this.documentId);

    return getAnnualStatementsPath(this.documentId);
  }
}
